export default {"src":"/_next/static/media/youtube-social.b9d7eb96.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};